import { Http } from "@angular/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";

@Injectable()
export class ConfigsService {
  // variáveis globais
  nome: string = "PsPrimeSoftware";
  logo: string = "assets/images/logo-prime.png";
  corPadrao: string = "#1E7975";

  urlApi: string = environment.host_backend;
  urlPublica: string = environment.host_backend;
  urlSocket: string = environment.host_backend;
  dadosEmpresa: any = {};

  constructor(private http: Http) {
    // define na storage os dados da empresa
    if (sessionStorage.getItem("dadosEmpresa")) {
      this.dadosEmpresa = sessionStorage.getItem("dadosEmpresa");
    } else {
      this.http.get(`${this.urlApi}/consultas/dadosEmpresa`).subscribe((r) => {
        this.dadosEmpresa = r.json();
        sessionStorage.setItem("dadosEmpresa", JSON.stringify(r.json()));
      });
    }
  }

  // função global de validação do médico com seu conselho
  async validaConselho(codgoMedico, conselhoMedico) {
    return new Promise((resolve, reject) => {
      try {
        this.http
          .get(
            `${this.urlApi}/medicos/validaConselho/${codgoMedico}/${conselhoMedico}`
          )
          .subscribe(
            (r) => {
              var retorno = r.json();
              if (retorno.sigla) {
                if (retorno.sigla == "CRM") {
                  resolve(3);
                } else if (retorno.sigla == "CRN") {
                  resolve(2);
                } else if (retorno.sigla == "CRF") {
                  resolve(1);
                } else {
                  resolve(-1);
                }
              } else {
                resolve(-2);
              }
            },
            (erro) => {
              console.log(erro);
              resolve(-3);
            }
          );
      } catch (e) {
        console.log(e);
        resolve(-4);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/configs.service.ts